import { useState, useEffect } from 'react';
import classNames from 'classnames/bind';


const instances = [];

const ExpandableMapControl = (props) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    instances.push(setExpanded);
    return () => {
      const idx = instances.indexOf(setExpanded);
      if (idx !== -1) instances.splice(idx, 1);
    };
  }, []);

  function toggleExpand(ev){
    ev.stopPropagation();
    const newExpanded = !expanded;
    setExpanded(newExpanded);
    if(newExpanded){
      if (props.onExpand) props.onExpand();
      instances.forEach((i) => i !== setExpanded && i(false));
    }
    if(!newExpanded && props.onCollapse) props.onCollapse();
  }

  return (
      <div className={classNames('map-control', 'expandable-map-control',
                                {'is-expanded': expanded})}>
        <div className='map-control-contents'>
          <div className='panel'>
            <div className='panel-content'>
              {props.children}
            </div>
          </div>
          <button onClick={toggleExpand}>
            {!expanded && props.openButton}
            {expanded && <i className='fa fa-xmark'/> }
          </button>
        </div>
      </div>
  );

};
export default ExpandableMapControl;
